<template>
  <div class="view">
    <el-row>
      <el-col :span="6">产品名称</el-col>
      <el-col :span="18">{{data.name}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6">分类</el-col>
      <el-col :span="18">{{data.category_name}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6">图片</el-col>
      <el-col :span="18"><img style="width:50px;height:50px":src="domainPic + data.photo" /></el-col>
    </el-row>
    <el-row>
      <el-col :span="6">中文描述</el-col>
      <el-col :span="18">{{data.description_cn}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6">备注</el-col>
      <el-col :span="18">{{data.memo}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6">所有客户</el-col>
      <el-col :span="18">
        <span v-for="item in data.customer_list" :key="item.id">{{ item.customer_number }}-{{ item.customer_name }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table
          :data="data.material_list"
          border
          stripe>
          <el-table-column
            fixed
            prop="material_number"
            label="配件编号"
            width="100">
          </el-table-column>
          <el-table-column
            fixed
            prop="material_name"
            label="配件名称"
            width="150">
          </el-table-column>
          <el-table-column
            label="图片">
            <template slot-scope="scope">
            <img style="width:50px;height:50px":src="domainPic + scope.row.material_photo" />
            </template>
          </el-table-column>
          <el-table-column
            prop="material_category_name"
            label="分类">
          </el-table-column>
          <el-table-column
            prop="quantity"
            label="数量">
          </el-table-column>
          <el-table-column
            prop="unit"
            label="单位">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script type="text/babel">
import constants from 'config/constants'
export default {
  name: 'SampleView',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      domainPic: constants.basic.domain_pic,
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.view
  padding: 0

</style>



// WEBPACK FOOTER //
// src/components/ProductView.vue